import {normalizeString} from './string'

export const createPermissionRules = ({resource, action, ...args}) => {
  return action && resource
    ? [normalizeString(action)]
        .concat(normalizeString(resource))
        .concat(Object.values(args).map(v => normalizeString(v)))
        .join('.')
    : ''
}
